import React from 'react';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { H5 } from '../../../AbstractElements';
import { SimplePricingCardTitle } from '../../../Constant';
import { SimplePricingCardData } from '../../../Data/Ecommerce/PricingCardData';
import SimplePricing from './SimplePricing';

const SimplePricingCard = () => {
  return (
    <Col sm='12'>
      <Card>
        <CardHeader className='pb-0'>
          <H5>{SimplePricingCardTitle}</H5>
        </CardHeader>
        <CardBody className='pricing-content'>
          <Row>
            {SimplePricingCardData.map((item, i) => (
              <Col sm='6' xl='3' className='box-col-3 xl-25' key={i}>
                <SimplePricing data={item} />
              </Col>
            ))}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SimplePricingCard;
